<template>
  <router-link
    class="notification row no-gutters align-items-center nounderline"
    :to="`/p/case/${entity.patient_case_id}`"
  >
    <!-- <div class="col-auto text-primary border-right p-3">
      <DrugsIcon v-if="entity.type === 'Drug'"></DrugsIcon>
      <RecomendIcon v-else></RecomendIcon>
    </div> -->
    <div class="col mb-2 p-3">
      <small class="text-muted">
        {{ $t(action) }}
      </small>
      <h4>
        {{ $t(entity.type) }}
        <small class="text-muted d-block">
          {{ entity.created_at | moment("ddd, DD MMMM, HH:mm") }}
        </small>
      </h4>
      <small
        class="m-0 d-block text-muted"
        v-if="entity.data && entity.data.text"
        :class="{ 'line-through': action === 'TreatmentItemCancelled' }"
      >
        {{ entity.data.text }}
      </small>
      <small
        class="m-0 d-block text-muted"
        v-if="entity.data && entity.data.name"
        :class="{ 'line-through': action === 'TreatmentItemCancelled' }"
      >
        <strong>{{ entity.data.name }}</strong> - {{ entity.data.instruction }}
      </small>
    </div>
    <div class="col-12 w-100"></div>
  </router-link>
</template>
<script>
// import DrugsIcon from '@/components/Icons/Drugs'
// import RecomendIcon from '@/components/Icons/Recomend'
export default {
  // components: {
  //   DrugsIcon,
  //   RecomendIcon
  // },
  props: {
    entity: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss">
.notification {
  .month {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 80px;
    font-size: 0.75em;
  }
  .day {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 44px;
    font-size: 2em;
  }
  svg {
    width: 75px;
    // height: 100px;
  }
}
</style>
<i18n>
{
  "ka": {
      "TreatmentItemCreated": "გამოქვეყნდა",
      "TreatmentItemCancelled": "გაუქმდა",
      "Recommendation": "რეკომენდაცია",
      "Drug": "დანიშნულება"
  },
  "en": {
      "TreatmentItemCreated": "Created",
      "TreatmentItemCancelled": "Cancelled",
      "Recommendation": "Recommendation",
      "Drug": "Drug"
  }
}
</i18n>
